import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchDraftTakeawayOrders = ({ owner, pos_profile } = {}) => {
    const filters = [["Draft Table Order", "status", "=", "Draft"]];
    let paramsOrFilters = null;
    if (owner) {
        paramsOrFilters = [
            ["Draft Table Order", "owner", "=", owner],
            ["Draft Table Order", "restaurant_storefront_order", "=", 1],
            ["Draft Table Order", "kiosk_order", "=", 1],
        ];
    }
    if (pos_profile) {
        filters.push(["Draft Table Order", "pos_profile", "=", pos_profile]);
    }

    const params = {
        doctype: "Draft Table Order",
        fields: JSON.stringify([
            "name",
            "customer",
            "customer_name",
            "address",
            "status",
            "table",
            "designated_number",
            "mobile_no",
            "address_line1",
            "address_line2",
            "delivery_provider",
            "creation",
            "modified",
            "amount",
            "alert_after_minutes",
            "alert_time",
            "owner",
            "pos_profile",
            "kiosk_order",
            "restaurant_storefront_order",
            "restaurant_storefront_order_mode",
        ]),
        filters: JSON.stringify(filters),
        order_by: "modified desc",
        limit_start: 0,
        limit_page_length: 100,
    };
    if (paramsOrFilters) params.or_filters = JSON.stringify(paramsOrFilters);

    return axios.get("method/frappe.client.get_list", { params });
};

export const useDraftTakeawayOrders = ({ owner, pos_profile } = {}) => {
    return useQuery(
        ["draftTakeawayOrders", owner || "", pos_profile || ""],
        async () => {
            const { data } = await fetchDraftTakeawayOrders({ owner, pos_profile });
            return data.message || [];
        },
        { refetchInterval: 15000 }
    );
};
